
  import { Component, Vue, Watch } from 'vue-property-decorator'
  import Table from '../components/Bridge/Table.vue'
  import ViewDetails from '../components/Bridge/View.vue'
  import Reports from '../components/Bridge/Reports.vue'
  import { components } from 'gmap-vue'

  @Component({
    components: {
      Table,
      ViewDetails,
      Reports,
      "gmap-cluster": components.Cluster
    }
  })

  export default class Bridge extends Vue  {
    editDialog = false
    oldItem = -1
    showMap = true
    deletingBridge = false
    tableCols = 4
    mapCols = 8
    map = null
    previewDialog: any = {
      show: false,
      title: '',
      cityId: '',
      stateId: ''

    }
    viewDialog = false
    headers: Array<object> = [
      {
        text: 'Bridge Name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      { text: 'City ID', value: 'cityId' },
      { text: 'State ID', value: 'stateId' },
      { text: 'County ID', value: 'countyId' },
      { text: 'Actions', value: 'actions', sortable: false },
    ]
    bridges: Array<any> = []
    editedIndex = -1
    editedItem: object = {
      id: 0,
      name: '',
      cityId: 0,
      stateId: 0,
      countyId: 0,
      cityOwnership: false,
      countyOwnership: false,
      stateOwnership: false,
      maintainedBy: '',
      yearBuilt: '',
      permitRating: '',
      roadway: false,
      paseo: false,
      bridge_permit_ratings: []
    }
    defaultItem: object = {
      id: 0,
      name: '',
      cityId: 0,
      stateId: 0,
      countyId: 0,
      cityOwnership: false,
      countyOwnership: false,
      stateOwnership: false,
      maintainedBy: '',
      yearBuilt: '',
      permitRating: '',
      roadway: false,
      paseo: false,
      bridge_permit_ratings: []
    }


    //Computed
    get formTitle(): string {
      return this.editedIndex === -1 ? 'New Bridge' : 'Edit Bridge'
    }

    get getBridges(): Array<string|number|boolean> {
      return this.$store.getters['bridge/getItems']
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }

    //Watch
    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.deletingBridge == true) {
        this.$store.dispatch('bridge/getBridges')
        this.$store.commit('bridge/setReload', false)
        this.deletingBridge = false
      }
    }
    @Watch('dialog')
    nameChanged(val: boolean) {
      val || this.close()
    }
    @Watch('getBridges')
    bridgeItems(val: Array<object>) {
      this.bridges = val
    }
    @Watch('showMap')
    watchMap(val: boolean) {
      if(val) {
        this.mapCols = 8
        this.tableCols = 4
      }
      else {
        this.mapCols = 0
        this.tableCols = 12
      }
    }

    //LifeCycle
    mounted () {
      this.initialize()
    }

    //Methods
    public initialize(): void {
      // @ts-ignore: I can't seem to add this to typescript correctly
      this.$refs.map.$mapPromise.then((map: any ) => {
        this.map = map
        this.$store.dispatch('bridge/getBridges')
      })
    }
    public goToItem(item: any): void {
      this.editedIndex = this.bridges.indexOf(item)
      if(this.oldItem > -1)
        this.$refs.markers[this.oldItem].$markerObject.setAnimation(0)
      this.oldItem = this.editedIndex
      //this.bridges[this.editedIndex].animation = 1
      this.$refs.markers[this.editedIndex].$markerObject.setAnimation(1)
      // @ts-ignore: I can't seem to add this to typescript correctly
      this.$refs.map.panTo({lat: item.lat,lng: item.lng});
    }
    public viewItem(item: object): void {
      // @ts-ignore: I can't seem to add this to typescript correctly
      this.$refs.map.panTo({lat: item.lat,lng: item.lng});
      this.editedIndex = this.bridges.indexOf(item)
      this.bridges[this.editedIndex].animation = 1
      this.editedItem = Object.assign({}, item)
      this.viewDialog = true
    }
    public editItem(item: object): void {
      this.editedIndex = this.bridges.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    }
    public deleteItem(item: object): void {
      //this.deletingBridge = true
      //const index = this.bridges.indexOf(item)
      //confirm('Are you sure you want to delete this item?') && this.bridges.splice(index, 1)
      confirm('Are you sure you want to delete this item?') && this.$store.dispatch('bridge/deleteBridge', item)
      //Dispatch
    }

    public openHover($event: any, item: any): void {
      this.previewDialog.show = true
      this.previewDialog.title = item.name
      this.previewDialog.cityId = item.cityId
      this.previewDialog.stateId = item.stateId
      let self
      self = this
      if(self.timeout) {
        clearTimeout(self.timeout)
      }
      self.timeout = setTimeout(function() {
        self.previewDialog.show = false
        self.previewDialog.title = null
        self.previewDialog.cityId = null
        self.previewDialog.stateId = null
      }, 10000)
      self = this
    }

    public closeView(): void {
      this.bridges[this.editedIndex].animation = 0
    }
    
    public close(): void {
      this.editDialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }
  }
